<template>
  <span>
    <span class="border-wrapper">
      <slot></slot>
    </span>
  </span>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped="">
.border-wrapper {
  border-left: 3px solid #e96b5a;
  padding-left: 10px;
}
</style>